export default {
  form: {
    tax_id: {
      label: 'Număr fiscal',
      placeholder: 'Introduceți numărul fiscal',
    },
    has_vat: {
      label: 'Este afacerea dvs. înregistrată în scop de TVA?',
    },
    vat_id: {
      label: 'TVA',
      placeholder: 'TVA',
      tooltip: 'Codul de TVA este un număr fiscal unic care identifică afacerea dvs.',
    },
    tax_percentage: {
      label: 'Procent taxă',
      placeholder: 'Procent taxă',
    },
    has_dedicated_products_tax: {
      label: 'Cota de taxă % diferă în funcție de produs',
    },
  },
  buttons: {
    next: 'Următor',
    back: 'Înapoi',
    skip: 'Omiteți',
  },
};
